import ActivityPhysical from './activityPhysical.js';
export default ActivityPhysical;
